import './styles/job-item.scss'

import React      from 'react'
import PropTypes  from 'prop-types'
import moment     from 'moment'
import classnames from 'classnames'

import RetryButton from './RetryButton'
import FailButton  from './FailButton'

import { canRetryJob, canFailJob } from '../utils'

function RetryLabel(props) {
  // eslint-disable-next-line react/prop-types
  const nRetries = props.item.retries.length
  const retried_successfully = (nRetries >=1) ? (props.item.retries[0].status =='DELIVERED') : false
  console.log("retry status",retried_successfully);
  if (retried_successfully){
    return (
      <div className="retry-container-successful">
        <div className="retried-placeholder">
          Status DELIVERED<br/>Type:Retried

          { nRetries > 1 && <div className="count">{ nRetries }</div> }
        </div>
      </div>
    )
  }else{
  return (
    <div className="retry-container">
      <div className="retried-placeholder">
        This job has been retried

        { nRetries > 1 && <div className="count">{ nRetries }</div> }
      </div>
    </div>
  )
 }
}

export default class JobItem extends React.Component {
  static propTypes = {
    item:    PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  }

  renderHighlight = (title, message, failed, delivered, duplicate, onhold, cancelled) => {
    const className = classnames('item-highlight ui mini message', { failed, delivered, duplicate, onhold, cancelled })

    return (
      <div className={className}>
        <div className="title">{ title }</div>
        <div className="message">{ message }</div>
      </div>
    )
  }

  render() {
    const { item, history } = this.props

    const title     = item.integration && item.integration.name
    const timestamp = moment(item.creationTimestamp).format('YYYY-MM-DD h:mm A')

    const failed     = item.status === 'FAILED'
    const delivered  = item.status === 'DELIVERED' || item.status === 'COMPLETED'
    const duplicate  = item.status === 'DUPLICATE'
    const onhold     = item.status === 'ON_HOLD'
    const cancelled  = item.status === 'CANCELLED'

    const retryable = canRetryJob({ job: item })
    const failable  = canFailJob({ job: item })
    const retried   = Array.isArray(item.retries) && item.retries.length > 0

    const headerClass = classnames('header', { failed, delivered })

    return (
      <div className="job-item">
        <div className={headerClass}>
          { title && <div className="title">{ title }</div> }

          <div className="timestamp">
            { timestamp }
          </div>
        </div>
        <div className="details">
          { item.sender    && this.renderHighlight('Sender',    item.sender.name )   }
          { item.receiver  && this.renderHighlight('Receiver',  item.receiver.name )   }
          { item.dataType  && this.renderHighlight('Data Type', item.dataType.name ) }
          { item.status    && this.renderHighlight('Status',    item.status, failed, delivered, duplicate, onhold, cancelled) }

          { retryable && !retried && (
            <div className="retry-container">
              <RetryButton job={item} history={history} />
            </div>
          ) }

          { failable && (
            <div className="retry-container">
              <FailButton job={item} history={history} />
            </div>
          ) }

          { retried && <RetryLabel { ...this.props } /> }
        </div>
      </div>
    )
  }
}
